import { render, staticRenderFns } from "./StoreGroupbuyingDraft.vue?vue&type=template&id=c55e2e0c&scoped=true&"
import script from "./StoreGroupbuyingDraft.vue?vue&type=script&lang=js&"
export * from "./StoreGroupbuyingDraft.vue?vue&type=script&lang=js&"
import style0 from "./StoreGroupbuyingDraft.vue?vue&type=style&index=0&id=c55e2e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55e2e0c",
  null
  
)

export default component.exports